// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Navbar style */
.nav-pages a{
     margin-right: 10px;
}

.nav-pages a:hover{
  border: 1px solid;
  font-weight: bold;
}


/* Location form style */
.add-location label, .submit-location{
  display: block;
  margin-top: 5px;
  margin-bottom: 2px;
}

.add-location label{
  font-size:16px;
}


/* map style */
.leaflet-left .leaflet-control {
  position: absolute !important;
  margin-top: 250px !important;
}


/* check in button style */
#check-in-button{
  z-index: 1000;
  background-color: rgb(16, 152, 23);
  border: none;
  border-radius: 1em;
  color: white;
  margin: 0.25em;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease, colour 0.3s ease;
}

#check-in-button:hover {
  z-index: 1000;
  background-color: #236b2f;
}


/* pop up confirmation styles */
#checkin-confirm {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: 200ms ease-in-out;
  z-index: 10000 !important;
  background:white;
  border: 1px solid #007bff;
  padding:50px;
  border-radius: 10px;
  width: 300px;
  max-width:500px;
  display:none;
}


.pop-up-button {
  background-color: rgba(0, 123, 255, 0.187);;
  border: none;
  border-radius: 1em;
  color: white;
  padding: 0.5em 1em;
  margin: 0.25em;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease, colour 0.3s ease;
}
  
.pop-up-button:hover {
  background-color: #007bff;
  color: white;
}


/* blur background when pop up active */

#blur-background{
  position: fixed;
  opacity: 0; 
  transition: 200ms ease-in-out;
  top:0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color:rgba(0,0,0, 0.2);
  pointer-events: none;
}

#blur-background.active{
  opacity: 1;
  pointer-events: all;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,iBAAiB;AACjB;KACK,kBAAkB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;;AAGA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;;AAGA,cAAc;AACd;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;;AAGA,0BAA0B;AAC1B;EACE,aAAa;EACb,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;;AAGA,+BAA+B;AAC/B;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;;AAGA;EACE,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;;AAGA,uCAAuC;;AAEvC;EACE,eAAe;EACf,UAAU;EACV,6BAA6B;EAC7B,KAAK;EACL,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Navbar style */\n.nav-pages a{\n     margin-right: 10px;\n}\n\n.nav-pages a:hover{\n  border: 1px solid;\n  font-weight: bold;\n}\n\n\n/* Location form style */\n.add-location label, .submit-location{\n  display: block;\n  margin-top: 5px;\n  margin-bottom: 2px;\n}\n\n.add-location label{\n  font-size:16px;\n}\n\n\n/* map style */\n.leaflet-left .leaflet-control {\n  position: absolute !important;\n  margin-top: 250px !important;\n}\n\n\n/* check in button style */\n#check-in-button{\n  z-index: 1000;\n  background-color: rgb(16, 152, 23);\n  border: none;\n  border-radius: 1em;\n  color: white;\n  margin: 0.25em;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, colour 0.3s ease;\n}\n\n#check-in-button:hover {\n  z-index: 1000;\n  background-color: #236b2f;\n}\n\n\n/* pop up confirmation styles */\n#checkin-confirm {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  transition: 200ms ease-in-out;\n  z-index: 10000 !important;\n  background:white;\n  border: 1px solid #007bff;\n  padding:50px;\n  border-radius: 10px;\n  width: 300px;\n  max-width:500px;\n  display:none;\n}\n\n\n.pop-up-button {\n  background-color: rgba(0, 123, 255, 0.187);;\n  border: none;\n  border-radius: 1em;\n  color: white;\n  padding: 0.5em 1em;\n  margin: 0.25em;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, colour 0.3s ease;\n}\n  \n.pop-up-button:hover {\n  background-color: #007bff;\n  color: white;\n}\n\n\n/* blur background when pop up active */\n\n#blur-background{\n  position: fixed;\n  opacity: 0; \n  transition: 200ms ease-in-out;\n  top:0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color:rgba(0,0,0, 0.2);\n  pointer-events: none;\n}\n\n#blur-background.active{\n  opacity: 1;\n  pointer-events: all;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
